import axios from '@axios'

const route = 'financial/invoice'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    index(context, { itemsPerPage, page, filters }) {
      return axios.post(`${route}/index?page=${page}&items_per_page=${itemsPerPage}`, filters)
    },

    getInvoice(context, id) {
      return axios.get(`${route}/sale/${id}`)
    },
    testNfe(context, data) {
      return axios.post(route + '/test', data)
    },

    // store(context, billsToPay) {
    //   return axios.post(route, billsToPay)
    // },

    update(context, invoice) {
      return axios.post(`${route}/check_status/${invoice.id}`, invoice)
    },

    // destroy(context, billsToPay) {
    //   return axios.delete(`${route}/${billsToPay.id}`)
    // },

    cancelInvoice(context, payload) {
      return axios.post(`${route}/cancel_invoice/${payload.id}`, payload)
    },


    exportExcel(context, payload) {
      return axios.post(`${route}/export_excel`, payload, { responseType: 'blob' })
    },

    saveCertificate(context, payload) {
      return axios.post(`${route}/save_certificate`, payload)
    },

    getCertificate(context) {
      return axios.get(`${route}/get_certificate`)
    }

  },
}
